import ServiceField from "./ServiceField";

/**
 * Next Service Mileage input — reuses the shared ServiceField (same theme,
 * RTL layout, typography, borders as every other mileage field).
 * Formatting (Persian digits + 3-digit separators) is handled by the parent
 * via `toPersianNumericDisplay`, exactly like the Service Mileage field.
 */
function NextServiceMileageField({
  value,
  onChange,
  label = "کیلومتر سرویس بعدی",
  placeholder,
  disabled = false,
}) {
  return (
    <ServiceField
      label={label}
      type="text"
      inputMode="numeric"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
}

export default NextServiceMileageField;
